import { createEntityAdapter, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

// export const getNotifications = createAsyncThunk('notificationManager/notifications/getNotifications', async (params, { dispatch }) => {
// 	return Utils.executeStored({
// 		action: 'st_sys_notifications_list',
// 		dispatch,
// 		params: { filters: [] },
// 		successHandler: response => {
// 			return response.data?.list || [];
// 		}
// 	});
// });

const notificationsAdapter = createEntityAdapter<any>({});
const initialState = notificationsAdapter.upsertMany(notificationsAdapter.getInitialState(), []);

export const { selectAll: selectNotifications, selectById: selectNotificationsById } =
	notificationsAdapter.getSelectors((state: any) => state.notifications.list);

const notificationsSlice = createSlice({
	name: 'notifications/list',
	initialState,
	reducers: {
		setNotifications: (state, action) => notificationsAdapter.addMany(initialState, action.payload),
		addNotification: (state, action) => notificationsAdapter.addOne(state, action.payload),
		dismissNotification: (state, action) => notificationsAdapter.removeOne(state, action.payload),
		dismissAllNotifications: (state, action) => notificationsAdapter.removeAll(state)
	},
	extraReducers: builder => {
		// builder.addCase(getNotifications.fulfilled, (state, action) =>
		// 	notificationsAdapter.addMany(state, action.payload)
		// );
	}
});

export const { setNotifications, addNotification, dismissNotification, dismissAllNotifications } =
	notificationsSlice.actions;

export default notificationsSlice.reducer;
